import { render, staticRenderFns } from "./contentDetailCivilization.vue?vue&type=template&id=245b7a24&scoped=true&"
import script from "./contentDetailCivilization.vue?vue&type=script&lang=js&"
export * from "./contentDetailCivilization.vue?vue&type=script&lang=js&"
import style0 from "./contentDetailCivilization.vue?vue&type=style&index=0&lang=css&"
import style1 from "./contentDetailCivilization.vue?vue&type=style&index=1&id=245b7a24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b7a24",
  null
  
)

export default component.exports